module.exports = __webpack_public_path__ + "static/media/non-op injection.4e9617ba.png";